var _path, _path2, _path3, _path4, _path5, _circle, _path6, _circle2, _circle3;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgStatoscope(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.1611 15.8379V27.8513C12.1611 29.0054 12.5881 30.7191 14.6939 30.7191C16.7996 30.7191 17.3365 29.0054 17.3365 27.8513V20.2046C17.3365 19.5038 17.6923 18.1021 19.1156 18.1021C20.5388 18.1021 21.2354 18.1021 21.6127 18.1021",
    stroke: "#FF8165",
    strokeWidth: 0.597333,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M7.50391 10.3809C7.91292 13.1139 9.79422 15.3375 12.6657 15.3375C14.8262 15.3375 16.6333 13.3049 17.2463 10.3809",
    stroke: "#1552E8",
    strokeWidth: 0.597333,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M12.5537 15.8379V27.8513C12.5537 29.0054 12.9807 30.7191 15.0864 30.7191C17.1922 30.7191 17.7291 29.0054 17.7291 27.8513V20.2046C17.7291 19.5038 18.0849 18.1021 19.5082 18.1021C20.9314 18.1021 21.6279 18.1021 22.0053 18.1021",
    stroke: "#081E54",
    strokeWidth: 0.597333,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M7.2168 3.55859V10.1896C7.27071 12.0225 8.38126 15.6884 12.3922 15.6884C16.4031 15.6884 17.5137 12.0225 17.5676 10.1896V3.55859",
    stroke: "#081E54",
    strokeWidth: 0.597333,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M7.2168 9.37305C7.80981 10.5591 9.67511 12.9311 12.3922 12.9311C15.1093 12.9311 16.9746 10.5591 17.5676 9.37305",
    stroke: "#081E54",
    strokeWidth: 0.597333,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 7.21632,
    cy: 2.09425,
    r: 1.15691,
    fill: "#E7EDFF",
    stroke: "#081E54",
    strokeWidth: 0.597333
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M18.7238 2.09425C18.7238 2.7332 18.2059 3.25117 17.5669 3.25117C16.928 3.25117 16.41 2.7332 16.41 2.09425C16.41 1.45531 16.928 0.937339 17.5669 0.937339C18.2059 0.937339 18.7238 1.45531 18.7238 2.09425Z",
    fill: "#E7EDFF",
    stroke: "#081E54",
    strokeWidth: 0.597333
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 24.4114,
    cy: 18.0902,
    r: 2.1079,
    stroke: "#081E54",
    strokeWidth: 0.597333
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 24.425,
    cy: 18.0705,
    r: 1.36735,
    fill: "#A020FF"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgStatoscope);
export default __webpack_public_path__ + "static/media/Statoscope.b3d1645598881d7627720dc47b6a2176.svg";
export { ForwardRef as ReactComponent };